var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 mb-12", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 d-flex align-center",
                      attrs: { cols: "auto" },
                    },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("Outbound Dispatch Status"),
                      ]),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "", color: "black" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "img",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "ml-3 tooltip-info-icon",
                                          attrs: {
                                            src: _vm.ic_outb_dispatch_info,
                                          },
                                        },
                                        "img",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", { staticClass: "br-10" }, [
                            _vm._v(
                              "Shipments are removed 3 days after delivery. View full history in My Shipments."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "5" } },
                    [
                      _c("smart-text-field", {
                        staticClass: "contracts-search",
                        attrs: {
                          placeholder: "Search by Shipment ID",
                          search: true,
                          clearable: true,
                          "background-color": "white",
                        },
                        on: {
                          "enter-pressed": _vm.applySearch,
                          clear: _vm.clearSearch,
                        },
                        model: {
                          value: _vm.searchTerm,
                          callback: function ($$v) {
                            _vm.searchTerm = $$v
                          },
                          expression: "searchTerm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 results-header",
                      attrs: { cols: "auto" },
                    },
                    [
                      _c("label", { staticClass: "search-result" }, [
                        _vm._v(_vm._s(_vm.formatNumber(_vm.totalCount))),
                      ]),
                      _c("span", { staticClass: "shipments-results-text" }, [
                        _vm._v(" dispatch records"),
                      ]),
                    ]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn-toggle",
                        {
                          staticClass: "fr",
                          class: { "w-100-pct mt-4": _vm.smAndDown },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "base bg-white filters-btn left",
                              class: { "w-100-pct": _vm.smAndDown },
                              attrs: { outlined: "" },
                              on: {
                                click: function ($event) {
                                  _vm.displayFilters = true
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: { width: "12", src: _vm.ic_filters },
                              }),
                              _vm._v(" Filters "),
                            ]
                          ),
                          _vm.mdAndUp
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "times-btn",
                                  on: { click: _vm.clearFilters },
                                },
                                [
                                  _c("img", {
                                    attrs: { width: "9", src: _vm.ic_times },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn-toggle",
                        {
                          staticClass: "fr",
                          class: { "w-100-pct": _vm.smAndDown },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "base bg-white filters-btn left",
                              class: { "w-100-pct": _vm.smAndDown },
                              attrs: { outlined: "" },
                              on: { click: _vm.csvExport },
                            },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: { width: "18", src: _vm.ic_download },
                              }),
                              _vm._v(" Export CSV "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "claims-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("outbound-dispatch-status-grid", {
                                attrs: {
                                  page: _vm.page,
                                  isAdminPortal:
                                    _vm.isUserAdminAndNotImpersonating,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: "700px", eager: "" },
          model: {
            value: _vm.displayFilters,
            callback: function ($$v) {
              _vm.displayFilters = $$v
            },
            expression: "displayFilters",
          },
        },
        [
          _c("outbound-dispatch-status-filters", {
            attrs: {
              searchInProgress: _vm.loading,
              clearTrigger: _vm.clearTrigger,
              initialShipmentId: _vm.searchTerm,
            },
            on: {
              search: _vm.search,
              close: function ($event) {
                _vm.displayFilters = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Outbound Dispatch Status"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }